import CollegeCatalogService from "@/services/CollegeCatalogService.js";
import LoggerService from "@/services/LoggerService.js";

export const namespaced = true;

export const state = {
    institutions: [],
    institution_count: "",
    search_term: ""
};

export const getters = {
    getInstitutionsWithCatalogs: state => {
        return state.institutions.filter(institution => institution.catalog_count > 0);
    },

    getInstitutionsWithCatalogsCount: state => {
        return state.institution_count;
    },

    getInstitutionById: state => id => {
        return state.institutions.find(institution => institution.id === id);
    },

    getCatalogCount: state => {
        // eslint-disable-next-line no-unused-vars
        let catCount = 0;
        return state.institutions.reduce((catCount, institution) => catCount + institution.catalog_count, 0);
    }
};

export const mutations = {
    SET_INSTITUTIONS(state, institutions) {
        state.institutions = institutions;
    },

    SET_INSTITUTION_COUNT(state, institutionCount) {
        state.institution_count = institutionCount;
    },

    SET_SEARCH_TERM(state, payload) {
        state.search_term = payload;
    }
};

export const actions = {
    fetchInstitutions({ commit }, params) {
        CollegeCatalogService.fetchInstitutions(params).then(response => {
            commit("SET_INSTITUTIONS", response.data.data);
            commit("SET_INSTITUTION_COUNT", response.data.count);
        });
    },

    // eslint-disable-next-line no-empty-pattern
    post({ commit }, logger) {
        LoggerService.post(logger).then(() => {
            // console.log(logger);
            commit("SET_SEARCH_TERM", logger);
        });
    }
};
